module.exports = __webpack_public_path__ + "static/media/fishy.c1aa02f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/fishy.png
// module id = 2560
// module chunks = 0